import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { map } from 'rxjs/operators';
import { interval } from 'rxjs';
declare let fbq:Function;

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  apiUrl: string;
  apiOr: string;

  constructor(private http: HttpClient) {
    this.apiOr = 'https://asaas-app.herokuapp.com';
    this.apiUrl = 'http://localhost:3000';
  }


  async getServidorStatus() {


    interval(60000).subscribe((data)=>{
      //let timeStart: number = performance.now();

      const url = `${this.apiOr}/serveron`;
      return this.http
        .get(url)
        .toPromise()
        .then((e) => {
          return e;
        });

    })


  }


  async criaAssinatura(ass: any) {
    Swal.fire({
      title: 'Estamos validando os dados.... aguarde',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
console.log(ass.assinatura.value)
    const headers = { 'content-type': 'application/json' };

    await this.http
      .post(`${this.apiOr}/assinatura`, ass, { headers: headers })
      .subscribe(
        (e: any) => {
          console.log('Resposta Assinatura');
          console.log(e);

          Swal.close();
          if ((e.data && e.data[0].billingType == 'BOLETO' ||e.data &&  e.data[0].billingType == "UNDEFINED")) {
            window.open(e.data[0].bankSlipUrl, '_blank');
            fbq('track', 'Boleto', {value: ass.assinatura.value , currency: 'BRL',payment:'Boleto'});
            let html =
              'Caso o boleto não abra automáticamente, clique abaixo ' +
              ` <a href="${e.data[0].invoiceUrl}" target="_blank">links</a> `;

            Swal.fire({
              title: 'Assinatura criada com sucesso',
              text:
                'Você receberá seu login e senha em seu e-mail assim que for compensado o pagamento',
              icon: 'success',
              html: html,
              showCancelButton: false,
            }).then((a) => {
              if (a.value) {

                window.open('https://painel.yourder.com.br')
              }
            });
          } else {

            fbq('track', 'Subscribe', {value: ass.assinatura.value , currency: 'BRL'});


            Swal.fire({
              title: 'Assinatura criada com sucesso',
              text:
                'Você receberá seu login e senha em seu e-mail assim que for compensado o pagamento',
              icon: 'success',
              showCancelButton: false,
            }).then((a) => {
              if (a.value) {
                window.open('https://painel.yourder.com.br')
              }
            });
          }
        },
        (error) => {
          let er: any = JSON.stringify(error.error.errors);
          let msg = JSON.parse(er);
          Swal.fire({
            title: msg[0].description,
            icon: 'error',
            allowEscapeKey: false,
            allowOutsideClick: false,
            timer: 3000,
          }).then(() => {
            Swal.close();

            console.log(msg[0].description);
          });
        }
      );
  }
}
